import styled from 'styled-components';

const S = {}

S.LogoWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 0 1.5rem;
    position: absolute;
    top: 0;
    left: 0;
    height: 140px;
    background: #fff;
    border-radius: 4px 20px;
    transition: all 0.4s;

    

    @media (max-width: 1280px) {
      position: initial;
      height: 80px;
      background: transparent;
    }

    & a {
        height: 100%;
        display: flex;
        align-items: center;

        & img {
        height: 50%;
        }
    }
`;

export default S;